<div class="main" cdkDropListGroup>
    <mat-tab-group class="folder-tabs-container" headerPosition="below" [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
        @if (followFolderRight && showfollowFolder) {
            <mat-tab label="Mes dossiers" labelClass="follow-folder-tab">
                <app-followed-folders-datas-list (folderDisplayed)="onFolderDisplayed($event)"></app-followed-folders-datas-list>
            </mat-tab>
        }
        <mat-tab label="LISTE" labelClass="folders-list-tab">
            <app-folders-list (folderDisplayed)="onFolderDisplayed($event)"></app-folders-list>
        </mat-tab>
        @for (tab of tabs; track tab.folderId; let index = $index) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="folder-tab" [matTooltip]="tab.folderName">{{ tab.folderName }}</div>
                    <div class="tab-icon-container">
                        <fa-icon [icon]="closeIcon" matTooltip="Fermer le dossier" matTooltipPosition="below" (click)="onFolderTabClosed(tab.folderId)"></fa-icon>
                    </div>
                </ng-template>
                <app-folder-detail-container [folderTabInfos]="tab" (closed)="onFolderTabClosed(tab.folderId)"></app-folder-detail-container>
            </mat-tab>
        }
    </mat-tab-group>
</div>
